import { Dropdown as DropdownMui } from '@mui/base/Dropdown';
import { MenuButton } from '@mui/base/MenuButton';
import { Menu } from '@mui/base/Menu';
import { MenuItem } from '@mui/base/MenuItem';
import React from 'react';
import s from './styles.scss';

export interface Props {
  label: React.ReactNode;
  menuItems: {
    label: React.ReactNode;
    isActive?: boolean;
    onClick?: (event: React.MouseEvent) => void;
    // showDivider?: boolean; // TODO: Fix me
  }[];
}

export const Dropdown = ({ label, menuItems }: Props) => {
  return (
    <DropdownMui>
      <MenuButton
        slotProps={{
          root: { className: s.menuButton },
        }}
      >
        {label}
      </MenuButton>
      <Menu slotProps={{ listbox: { className: s.listbox } }}>
        {menuItems.map((menuItem, i) => (
          <MenuItem
            key={i}
            onClick={menuItem.onClick}
            className={menuItem.isActive ? s.isActive : ''}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </Menu>
    </DropdownMui>
  );
};
